<template>
<div style="height: 100%;background-color: white">
  <div style="height: 20px"></div>
  <div style="margin: 0 20px;height: 50px">
    <el-input
      prefix-icon="el-icon-search"
      placeholder="输入IMEI搜索，例：xxxxxxxxxxx,xxxxxxxxxxx, ..."
      v-model="searchKeyword"
      clearable
      style="width: 400px"
    @blur="blurTable">
    </el-input>&nbsp;
    <el-button type="primary" @click="searchDevicePre()">搜索</el-button>
    <el-button icon="el-icon-s-tools" type="primary" @click="setOpenDevice()">批量出厂分配</el-button>
  </div>
  <div style="margin: 0 20px;max-height: calc(100% - 140px)">
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top: 10px"
      highlight-current-row
      ref="singleTable">
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        prop="deviceid"
        label="IMEI"
        min-width="140"
        align="center">
      </el-table-column>
      <el-table-column
        label="所属组织"
        min-width="150"
        align="center">
        <template slot-scope="scope">
          {{orgName(scope.row.preorgid)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="ship_time"
        label="出厂时间"
        min-width="140"
        align="center">
        <template slot-scope="scope">
          {{getShipTime(scope.row.ship_time)}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="130">
        <template slot-scope="scope">
          <el-button icon="el-icon-s-tools" type="primary" plain size="mini" @click="setDevice(scope.row)">出厂分配</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 10px;height: 40px;text-align: center">
    <el-pagination v-fixZoom
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCells">
    </el-pagination>
  </div>
  <el-dialog
    title="批量出厂分配"
    :visible.sync="setShow"
    v-if="setShow"
    width="550px"
    :show-close="true"
    :close-on-click-modal="false"
    center>
    <div style="width: 100%">
      <el-form style="margin-right: 30px" :model="sendForm" :rules="addAccRules" ref="sendForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="IMEI号" prop="textarea">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入IMEI号，例：xxxxxxxxxxx,xxxxxxxxxxx, ..."
            v-model="sendForm.textarea">
          </el-input>
        </el-form-item>
        <el-form-item label="组织" prop="preorgid">
          <el-cascader v-fixZoom
            style="width: 100%"
            :options="treeData"
            v-model="sendForm.preorgid"
            :filterable="true"
            placeholder="请选择所属组织"
            :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
            ref="treeData">
          </el-cascader>
        </el-form-item>
      </el-form>
      <div style="margin-top: 30px">
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="setShow = false">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="commitUpdateSet('sendForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {querydevicepreorg, updatedevicepreorg, searchdevicepreorg} from '../../api/factoryReset'

export default {
  name: 'deviceFactoryReset',
  data () {
    return {
      searchKeyword: '',
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      orgArr: [],
      treeData: [],
      setShow: false,
      textarea: '',
      sendForm: {
        textarea: 0,
        preorgid: ''
      },
      addAccRules: {
        textarea: [
          { required: true, message: '请输入IMEI号', trigger: 'blur' }
        ],
        preorgid: [
          { required: true, message: '请选择组织', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getOrgData()
  },
  methods: {
    // 组织
    getOrgData () {
      queryorg().then(res => {
        this.orgArr = res.data.org
        this.getTableData()
        let lastLevel = 100
        const arr = res.data.org
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getTableData () {
      this.searchKeyword = ''
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      querydevicepreorg(params).then(res => {
        this.tableData = res.data.devicepreorg
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    orgName (id) {
      for (let i = 0; i < this.orgArr.length; i++) {
        if (id === this.orgArr[i].id) {
          return this.orgArr[i].name
        }
      }
    },
    getShipTime (time) {
      if (time === '0000-00-00 00:00:00') {
        return ''
      } else {
        return time
      }
    },
    setDevice (row) {
      this.sendForm.textarea = row.deviceid
      this.sendForm.preorgid = ''
      this.setShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableData()
    },
    blurTable () {
      if (this.searchKeyword === '') {
        this.getTableData()
      }
    },
    searchDevicePre () {
      if (this.searchKeyword !== '') {
        let arr = this.searchKeyword.split(',')
        let arr1 = []
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] !== '') {
            arr1.push(arr[i])
          }
        }
        let data = {
          imeis: arr1
        }
        searchdevicepreorg(data).then(res => {
          this.tableData = res.data.devicepreorg
          this.totalCells = res.data.cnt
        }).catch(() => {})
      }
    },
    setOpenDevice () {
      this.sendForm.textarea = ''
      this.sendForm.preorgid = ''
      this.setShow = true
    },
    commitUpdateSet (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = this.sendForm.textarea.split(/\n|:|,/)
          this.getSendData(arr)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSendData (arr) {
      /* 353537064991833
        353537065998993
        353537065470647
        353537065999520
        353537065999488
        868593031000024
        353537065999496 */
      let arr1 = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          arr1.push(arr[i])
        }
      }
      let data = {
        preorgid: this.sendForm.preorgid,
        imeis: arr1
      }
      updatedevicepreorg(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置出厂分配',
          type: 'success',
          duration: 2000
        })
        this.getTableData()
        this.setShow = false
      }).catch(() => {
        this.setShow = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemlog/deviceFactoryReset.vue